// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hzUr","textarea":"styles_textarea__1z0MY"};